import { type MessageDTO, type PreviewItemDTO } from "~/features/bulkAddToCart/types/dtos";
import { type MessageModel, type PreviewItem } from "~/features/bulkAddToCart/types/models";
import { getNextUID } from "~/common/utils/uid";

export function transformPreviewItem(dto: PreviewItemDTO): PreviewItem {
  const targetPrice = dto.targetPrice ?? undefined;

  return {
    onSale: !!dto.onSale,
    housingProduct: dto.housingProduct,
    id: getNextUID(),
    quantity: dto.quantity,
    productId: dto.productId,
    requestedDeliveryDate: dto.requestDeliveryDate ? new Date(dto.requestDeliveryDate) : undefined,
    messages: dto.messages.map(transformMessage),
    comment: dto.comment,
    isCommentVisible: false,
    priceReference: dto.priceReference || "",
    quantityVisible: dto.quantityVisible ?? true,
    marketType: dto.type,
    succeedingProductUrl: dto.succeedingProductUrl,
    succeedingProductDesignation: dto.succeedingProductDesignation,
    customerOrderNumber: dto.customerOrderNumber,
    // Treat non-positive or missing target price as undefined so blank uploads stay blank
    targetPrice: targetPrice && targetPrice > 0 ? targetPrice : undefined,
  };
}

function transformMessage(dto: MessageDTO): MessageModel {
  return {
    type: dto.type === "INFO" ? "info" : "error",
    code: dto.code,
    params: dto.additionalParams,
  };
}
